import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';

const GuideSecurityOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="セキュリティチェック"
      description="月次セキュリティチェックの管理・実施を行う機能です。管理者がチェックを開始し、全ユーザーが月次確認とPCパッチ確認を実施します。"
    >
      <GuideSection title="ガイド一覧">
        <Stack spacing={1.5}>
          <Stack spacing={0.5}>
            <GuideLink to="security/admin-start">
              セキュリティチェックを管理する（管理者）
            </GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              月次セキュリティチェックの開始・管理を行います。
            </Typography>
          </Stack>
          <Stack spacing={0.5}>
            <GuideLink to="security/user-execute">セキュリティチェックを実施する</GuideLink>
            <Typography variant="caption" color="text.secondary" sx={{ pl: 3 }}>
              月次確認とPCパッチ確認を実施・提出します。
            </Typography>
          </Stack>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideSecurityOverview;
